import React from 'react';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import moment from 'moment';
import { ProgressBar } from 'primereact/progressbar';
import styles from "../../cards.module.scss"

function EventItem({ event, handleClickEvent, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickEvent}>
      <img
        className={styles.projectImage}
        src={event.image ? event.image.file : getImage('img-ph.png')}
        alt={event.image ? event.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>

        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <span className={styles.subtitle}>{moment(event.start_dt).format('LLL')}</span>
        </div>
      </div>

      {/* <div className="flex flex-row items-start w-full justify-between gap-5">
        <div className="font-bold">{event.attendees.length}</div>
        <div className="font-bold">{event.max_attendee_nb}</div>
      </div> */}
    </div>
  );
}

export default EventItem;
